<template>
  <div class="tabela-busca-ncm-container">
    <Paginacao produtos semGrid="7" :conteudo="conteudoFiltrado" @pagina="p => (ncmsPaginadas = p)">
      <div class="tabela-busca-ncm-altura">
        <TabelaPadrao
          v-if="conteudoFiltrado && conteudoFiltrado.length > 0"
          :clickLinha="click"
          templateColumns="150px 5fr"
          :conteudoPaginado="ncmsPaginadas"
          :conteudoTotal="conteudo"
          :estruturaTabela="estruturaTabela"
          alertaVermelho="Identificamos que o produto não se encontra mais vigente ou foi alterado, entretanto localizamos uma ou mais NCMs correlacionadas vigentes que podem substituir. <br>Clique aqui para selecionar uma nova NCM."
          caminhoAlertaVermelho="vigente"
          mensagemRepetido="Essa NCM já consta na lista de NCMs selecionadas."
          :apagaOrdenacao="apagaOrdenacao"
        />
        <div class="tabela-busca-ncm-vazio" v-else>
          Sem resultado para essa pesquisa
        </div>
      </div>
    </Paginacao>
  </div>
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "TabelaBuscaNcm",
  components: {
    TabelaPadrao,
    Paginacao
  },
  props: {
    conteudo: Array,
    conteudoFiltrado: Array,
    apagaOrdenacao: Boolean,
    selecionaNcm: Function,
    fechaTabelaBusca: Function,
    setLoading: Function
  },
  data() {
    return {
      ncmsPaginadas: [],
      estruturaTabela: [
        { nome: "NCM", valor: "ncm", alinhamento: "centro" },
        { nome: "DESCRIÇÃO", valor: "descricao" }
      ]
    };
  },
  watch: {
    ncmsPaginadas: {
      deep: true,
      async handler() {
        await this.checaRepetido();
        // if (!this.conteudo.filter(f => !f.repetido).length) {
        //   this.fechaTabelaSuspensa();
        // }
      }
    }
  },
  computed: {
    ...mapGetters("listaNcm", [
      "getContador",
      "getNcms",
      "getMensagemNotificacao",
      "getArNcmSelecionados"
    ]),
    ...mapGetters("login", ["getUser", "getAssinatura"])
  },

  methods: {
    async click(produto) {
      this.selecionaNcm(produto);
    },
    async checaRepetido() {
      await this.conteudo.forEach(e => {
        let repetido = !!this.getArNcmSelecionados.find(f => f.ncm == e.ncm && f.ex == e.ex);
        this.$set(e, "repetido", repetido);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tabela-busca-ncm-container {
  // border: 1px solid var(--cinza1);
  padding: 14px 0;
  // border-radius: 6px;
}
.tabela-busca-ncm-altura {
  min-height: 305px;
}
.tabela-busca-ncm-vazio {
  display: flex;
  justify-content: center;
}
</style>
